import httpSchoolClient from '@/plugins/httpSchoolClient';

export default {
  login(data) {
    return httpSchoolClient.post('school/session', { school: { ...data } });
  },
  logout() {
    return httpSchoolClient.delete('school/session');
  },
  getSchool() {
    return httpSchoolClient.get('school/info');
  },
  update(expert) {
    return httpSchoolClient.patch('school/info', { expert });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/schoolAuth.js